import InvoiceItemResource from "./invoiceItem.resource";

const invoiceItemModule = angular
  .module("app.resources.invoiceItem", [])
  .service("InvoiceItem", InvoiceItemResource);

export default invoiceItemModule;



// WEBPACK FOOTER //
// ./src/resources/invoiceItem/invoiceItem.module.js